// 快捷表格选择绑定
import { Dispatch, Key, SetStateAction, useState } from "react";
import { TableRowSelection } from "antd/lib/table/interface";

export default function useSelection<T = any>(
    props?: TableRowSelection<T>
): TableRowSelection<T> & {
    selected: Key[];
    setSelected: Dispatch<SetStateAction<Key[]>>;
} {
    const [selected, setSelected] = useState<Key[]>([]);

    return {
        ...props,
        onChange: (keys: Key[]) => setSelected(keys),
        selected,
        setSelected
    };
}
